// extracted by mini-css-extract-plugin
export default {"wixFee":"_4hx+4"};